/**
 * Organizations
 */
import { setOrganizations } from "./organization";
// ============
import { batchActions } from "redux-batched-actions";
import ActionHelpers from "./helpers";
import AUTH_CONST from "constants/auth";
import USER_CONST from "constants/user";
import axios from "axios";
import { setJWT, clearJWT, decodeTokenUUID, authBearerToken } from "utils/auth";
import Analytics, { USER_SIGNUP } from "utils/analytics";
import { deconstructReducerData } from "utils/data";
export const USER_ASSOC_KEYS = ["onboardings", "organizations"];
// const DEFAULT_LOGOUT_MSG = "Logged Out Successfully.";
/**
 * resetAuthNotes
 *
 */
export function resetAuthNotes(payload) {
  return (dispatch) => {
    dispatch({
      type: AUTH_CONST.UPDATE_AUTH_STORE,
      payload
    });
  };
}

/**
 * Logout
 *
 * @api public
 */
export function logout(callback = () => {}) {
  return (dispatch) => {
    logoutWithDispatch(dispatch, callback);
  };
}

export function logoutUser() {
  return {
    type: USER_CONST.LOGOUT_USER,
    payload: null
  };
}

export function logoutWithDispatch(dispatch) {
  dispatch(logoutUser());
}

export function loginSuccess(payload) {
  return {
    type: USER_CONST.UPDATE_USER,
    payload
  };
}

/**
 * emailSignup
 */
export function emailSignup(params, callback = () => {}) {
  return (dispatch) => {
    dispatch(
      ActionHelpers.loadingAction(
        AUTH_CONST.UPDATE_AUTH_STORE,
        "create",
        "user",
        "Create user record"
      )
    );
    const REQUEST_URL = `${process.env.NEXT_PUBLIC_API_ROOT}/v1/signup`;
    axios({
      method: "post",
      url: REQUEST_URL,
      data: {
        ...params,
        password_confirmation: params.password
      }
    })
      .then(({ data }) => {
        setJWT(data.jwt);
        const uuid = decodeTokenUUID(data.jwt);
        Analytics.aliasUser({ uuid });
        Analytics.track(USER_SIGNUP);

        dispatch(
          batchActions([
            ActionHelpers.clearLoader(AUTH_CONST.UPDATE_AUTH_STORE)
          ])
        );
        callback(null, data);
      })
      .catch((err) => {
        dispatch(
          batchActions(
            ActionHelpers.errorAndClear(
              AUTH_CONST.UPDATE_AUTH_STORE,
              err,
              false,
              dispatch
            )
          )
        );
        callback(err);
      });
  };
}

/**
 * emailLogin
 */
export function emailLogin(params, callback = () => {}) {
  return (dispatch) => {
    dispatch(
      ActionHelpers.loadingAction(
        AUTH_CONST.UPDATE_AUTH_STORE,
        "create",
        "user",
        "Login User"
      )
    );
    const REQUEST_URL = `${process.env.NEXT_PUBLIC_API_ROOT}/v1/sign-in`;

    axios({
      method: "post",
      url: REQUEST_URL,
      data: params
    })
      .then(({ data }) => {
        setJWT(data.jwt);
        const uuid = decodeTokenUUID(data.jwt);
        Analytics.identifyUser({ uuid });

        dispatch(
          batchActions([
            ActionHelpers.clearLoader(AUTH_CONST.UPDATE_AUTH_STORE)
          ])
        );
        callback(null, data);
      })
      .catch((err) => {
        dispatch(
          batchActions(
            ActionHelpers.authErrorAndClear(
              AUTH_CONST.UPDATE_AUTH_STORE,
              err,
              false,
              dispatch
            )
          )
        );
        callback(err);
      });
  };
}

/**
 * exchangeToken
 */
export function exchangeToken(ott, callback = () => {}) {
  return (dispatch) => {
    dispatch(
      ActionHelpers.loadingAction(
        AUTH_CONST.UPDATE_AUTH_STORE,
        "create",
        "auth",
        "Token exchange"
      )
    );
    const REQUEST_URL = `${process.env.NEXT_PUBLIC_API_ROOT}/v1/users/token-exchange?ott=${ott}`;

    axios
      .get(REQUEST_URL)
      .then(({ data }) => {
        setJWT(data.jwt);
        const uuid = decodeTokenUUID(data.jwt);
        Analytics.identifyUser({ uuid });

        dispatch(
          batchActions([
            ActionHelpers.clearLoader(AUTH_CONST.UPDATE_AUTH_STORE)
          ])
        );
        callback(null, data);
      })
      .catch((err) => {
        dispatch(
          batchActions(
            ActionHelpers.errorAndClear(
              AUTH_CONST.UPDATE_AUTH_STORE,
              err,
              false,
              dispatch
            )
          )
        );
        callback(err);
      });
  };
}

function handleAuthResponse(
  dispatch,
  callback,
  message = "",
  surpress = false
) {
  return (err, data) => {
    if (err) {
      dispatch(
        batchActions(
          ActionHelpers.errorAndClear(
            AUTH_CONST.UPDATE_AUTH_STORE,
            err,
            surpress,
            dispatch
          )
        )
      );
    } else {
      let actions = [ActionHelpers.clearLoader(AUTH_CONST.UPDATE_AUTH_STORE)];

      if (data) {
        const reducers = deconstructReducerData(data, "user", [
          "onboardings",
          "organizations",
          "licenses",
          "applications",
          "deployments",
          "manifests",
          "metadatas",
          "features",
          "variables",
          "feature_groups",
          "themes",
          "subscriptions",
          "short_links",
          "payment_methods",
          "merchant_accounts",
          "integrations",
          "user_applications",
          "user_manifests",
          "user_merchant_accounts",
          "user_features",
          "user_feature_groups",
          "user_short_links",
          "organizations.licenses",
          "organizations.organization_applications",
          "organizations.organization_manifests",
          "organizations.applications",
          "organizations.deployments",
          "organizations.subscriptions",
          "organizations.manifests",
          "organizations.integrations",
          "organizations.metadatas",
          "organizations.features",
          "organizations.variables",
          "organizations.themes",
          "organizations.feature_groups",
          "organizations.short_links",
          "organizations.payment_methods",
          "organizations.merchant_accounts",
          "organizations.organization_merchant_accounts",
          "organizations.organization_features",
          "organizations.organization_feature_groups",
          "organizations.organization_short_links"
        ]);

        actions = actions.concat([
          ActionHelpers.clearLoader(AUTH_CONST.UPDATE_AUTH_STORE),
          loginSuccess(reducers.user),
          setOrganizations(reducers.organizations),
          {
            type: AUTH_CONST.SET_AUTH,
            payload: {
              email: reducers.user.email
            }
          }
        ]);
      }

      dispatch(batchActions(actions));
    }
    callback(err);
  };
}

export function fetchUserDetails(surpress, callback = () => {}) {
  return (dispatch) => {
    dispatch(
      ActionHelpers.loadingAction(
        AUTH_CONST.UPDATE_AUTH_STORE,
        "create",
        "login",
        "Logging in"
      )
    );

    const REQUEST_URL = `${process.env.NEXT_PUBLIC_API_ROOT}/v1/login`;
    const requestHeaders = { headers: authBearerToken() };

    return axios
      .get(REQUEST_URL, requestHeaders)
      .then(({ data }) => {
        handleAuthResponse(dispatch, callback, null, surpress)(null, data);
      })
      .catch((err) => {
        clearJWT();

        dispatch(
          batchActions(
            ActionHelpers.errorAndClear(
              AUTH_CONST.UPDATE_AUTH_STORE,
              err,
              surpress,
              dispatch
            )
          )
        );
        callback(err);
      });
  };
}

export function emailResetRequest(params, callback = () => {}) {
  return (dispatch) => {
    dispatch(
      ActionHelpers.loadingAction(
        AUTH_CONST.UPDATE_AUTH_STORE,
        "reset",
        "user",
        "Reset user email"
      )
    );
    const REQUEST_URL = `${process.env.NEXT_PUBLIC_API_ROOT}/v1/reset/email/request`;

    axios({
      method: "post",
      url: REQUEST_URL,
      data: params
    })
      .then(({ data }) => {
        dispatch(
          batchActions([
            ActionHelpers.clearLoader(AUTH_CONST.UPDATE_AUTH_STORE),
            ActionHelpers.successNote(
              AUTH_CONST.UPDATE_AUTH_STORE,
              "Check your inbox for reset instructions. Can't find it? Check your spam folder too."
            )
          ])
        );
        callback(null, data);
      })
      .catch((err) => {
        dispatch(
          batchActions(
            ActionHelpers.errorAndClear(
              AUTH_CONST.UPDATE_AUTH_STORE,
              err,
              false,
              dispatch
            )
          )
        );
        callback(err);
      });
  };
}

export function emailResetConfirm(params, callback = () => {}) {
  return (dispatch) => {
    dispatch(
      ActionHelpers.loadingAction(
        AUTH_CONST.UPDATE_AUTH_STORE,
        "reset",
        "user",
        "Confirm user email reset"
      )
    );

    const REQUEST_URL = `${process.env.NEXT_PUBLIC_API_ROOT}/v1/reset/email/confirm`;

    axios({
      method: "post",
      url: REQUEST_URL,
      data: params
    })
      .then(({ data }) => {
        dispatch(
          batchActions([
            ActionHelpers.clearLoader(AUTH_CONST.UPDATE_AUTH_STORE),
            ActionHelpers.successNote(
              AUTH_CONST.UPDATE_AUTH_STORE,
              "Password reset successful. Please sign in again."
            )
          ])
        );
        callback(null, data);
      })
      .catch((err) => {
        dispatch(
          batchActions(
            ActionHelpers.errorAndClear(
              AUTH_CONST.UPDATE_AUTH_STORE,
              err,
              false,
              dispatch
            )
          )
        );
        callback(err);
      });
  };
}
